/*
 *
 * Users actions
 *
 */

import { createAction } from '@reduxjs/toolkit';

import { SLICE_NAME } from './constants';

export const fetchUsers = createAction<boolean>(
  `${SLICE_NAME}/fetchUsers`,
);
